/**
 * Puschies Pflege-Upsell (blocks/p-care-material.liquid): Button legt 1 Stück der Upsell-Variante in den Warenkorb
 * (Hyper custom_liquid_PFLEGE: „Wird hinzugefügt…“ → „✓ Hinzugefügt“ bzw. Fehler, nach 2 s zurück).
 * Warenkorb-Symbol + Drawer-Inhalt aktualisieren sich über Theme CartLinesUpdateEvent (ohne Drawer zu öffnen).
 */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.pCareUpsellInit) {
  window.pCareUpsellInit = true;

  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-p-care-add]') : null;
    if (!button || button.disabled) return;
    event.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const original = button.innerHTML;
    const setLabel = (text) => {
      button.innerHTML = '';
      const span = document.createElement('span');
      span.className = 'p-care-upsell__btn-default';
      span.textContent = text;
      button.appendChild(span);
    };

    button.disabled = true;
    button.classList.remove('is-success', 'is-error');
    setLabel(button.dataset.adding);

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'update',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, sections: sectionIds.join(',') }),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const added = await response.json();
      const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
        r.json()
      );
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { sections: added.sections, itemCount: cart.item_count, source: 'p-care-upsell' },
      });
      setLabel(button.dataset.added);
      button.classList.add('is-success');
    } catch (error) {
      console.error('[p-care-upsell] add failed', error);
      deferred.reject(error);
      setLabel(button.dataset.error);
      button.classList.add('is-error');
    }

    setTimeout(() => {
      button.innerHTML = original;
      button.disabled = false;
      button.classList.remove('is-success', 'is-error');
    }, 2000);
  });
}
